const actions = {
    LOGGER_ENQUEUE_ACTION_401_QUEUE: 'LOGGER_ENQUEUE_ACTION_401_QUEUE',
    LOGGER_DEQUEUE_ACTION_401_QUEUE: 'LOGGER_DEQUEUE_ACTION_401_QUEUE',
    LOGGER_CLEAR_ACTIONS_401_QUEUE: 'LOGGER_CLEAR_ACTIONS_401_QUEUE',

    LOGGER_LOG_LAST_API_CALL: 'LOGGER_LOG_LAST_API_CALL',

    LOGGER_RESET_STATE: 'LOGGER_RESET_STATE',

    logLastApiCall: lastApiCallObject => ({
        type: actions.LOGGER_LOG_LAST_API_CALL,
        lastApiCallObject,
    }),
};

export default actions;
